import React from 'react'
import { useTranslation } from 'react-i18next'

import { AxiosError } from 'axios'

import { getUserTransactions } from 'src/axious/user-transactions'
import { Header } from 'src/components'
import { useChangeBackground } from 'src/hooks/useChangeBackground'

import styles from './HistoryOfTransactions.module.scss'
import { TransactionItem } from './components'
import { splitByDates } from './utils/splitByDates'

export type UserTransactionType = {
  id: number
  user_id: number
  amount_stars: number
  commission: number
  type: 'DEPOSIT' | 'TRANSFER' | 'WITHDRAWAL' | 'INVESTMENT' | 'WIN' | 'LOSE'
  from: null | string
  recipient: null | string
  created_at: string
  ToUser: {
    id: string
    first_name: string
    last_name: string
    username: string
  } | null
  FromUser: {
    id: string
    first_name: string
    last_name: string
    username: string
  } | null

  Withdrawal: {
    id: number
    status: string
    type: string
    updatedAt: Date
    createdAt: Date
  } | null
}

const HistoryOfTransactions = () => {
  const { t } = useTranslation()
  const [data, setData] = React.useState<any>([])
  useChangeBackground(styles['history-of-transactions'])

  React.useEffect(() => {
    async function getData() {
      try {
        const data = await getUserTransactions()
        setData(splitByDates(data))
      } catch (err) {
        if (err instanceof AxiosError) {
          if (err.response) {
            console.log('Server error:', err.response.status, err.response.data)
          } else if (err.request) {
            console.log('Network error:', err.request)
          } else {
            console.log('Unexpected error:', err.message)
          }
        } else {
          console.log('Non-Axios error:', err)
        }
      }
    }

    getData()
  }, [])

  return (
    <>
      <Header variant='settings' setting={t('main_page.history_of_transactions')} color='black' />

      <div className={styles.history_list}>
        {data &&
          data.map((item: UserTransactionType[]) => {
            return <TransactionItem transactions={item} t={t} />
          })}
      </div>
    </>
  )
}

export default HistoryOfTransactions
